import { Wording } from '@/types';

export const PILATES_WORDING_SK: Wording = {
  components_header_media_content: 'Tréningy',
  components_header_media_1: '',
  components_header_media_2: '',
  components_header_text1: 'Recepty',
  components_header_text2: 'Blog',
  components_header_members: 'členov',
  hero_text: 'Udržujte svoje telo pružné a silné',
  hero_button_text: 'Začnite svoju cestu Pilates',
  components_ressources_section_title: 'ZDROJE',
  components_ressources_subheader_text:
    'Všetky zdroje, ktoré potrebujete pre harmonický životný štýl',
  components_ressources_span_text:
    'Odhaľte tajomstvá wellness: Ponorte sa do zbierky cvičení Pilates a zdravých receptov na vytvorenie rovnováhy v každom aspekte vášho života.',
  components_ressources_card_1_title: 'Tipy na pilates',
  components_ressources_card_1_text:
    'Praktické rady na prehĺbenie vašej praxe a zdokonalenie vašej rutiny.',
  components_ressources_card_2_title: 'Diéta',
  components_ressources_card_2_text:
    'Inteligentné výživové tipy pre zdravšie a silnejšie vás.',
  components_ressources_link: 'Pozrite si videá',
  components_notes_and_google_title_1: 'Pilates',
  components_notes_and_google_title_2: 'Pravidelná rutina',
  components_notes_and_google_title_3: 'Udržiavanie stravy',
  components_review_google_text: 'Recenzia na Googli',
  media_content_section_title: 'TRÉNINGY',
  media_content_section_subheader_text: 'Naše videá',
  text_media_1: '',
  text_media_2: '',
  media_content_section_button_more: 'Ďalšie videá',
  text2_section_title: 'BLOG',
  text2_section_subheader_text: 'Články a správy',
  text2_section_button_more: 'Ďalšie články',
  components_text1_section_title: 'RECEPTY',
  components_text1_subheader_text: 'Vyživujte svoje telo a myseľ',
  components_text1_span_text:
    'Zdravé recepty na podporu vašej rutiny pilatesu a zlepšenie vašej pohody.',
  components_text1_card_1_title: 'Energizujúce raňajky',
  components_text1_card_1_text:
    'Zobuďte sa na sýte jedlá, ktoré zvyšujú energiu.',
  components_text1_card_3_title: 'Obedy nabité energiou',
  components_text1_card_3_text:
    'Objavte chutné a pohodlné recepty na obedy navrhnuté pre váš aktívny životný štýl. Od farebných šalátov až po bielkovinové zábaly – tieto recepty vás nabijú energiou a sústredia sa.',
  components_text1_card_2_title: 'Večere na zotavenie',
  components_text1_card_2_text:
    'Preskúmajte rôzne chudé bielkoviny, celozrnné výrobky a živú zeleninu pre uspokojivý koniec dňa.',
  components_text1_link: 'Pozrite si všetky recepty',
  components_footer_text:
    'Nájdite rovnováhu, zhlboka sa nadýchnite: Váš Pilates, Vaša cesta.',
  components_footer_info: 'Info',
  components_footer_registration_number: 'Registračné číslo',
  components_footer_legal: 'Právne',
  components_footer_terms: 'Zmluvné podmienky',
  components_footer_privacy: 'Zásady ochrany osobných údajov',
  button_load_more: 'Načítať viac',
  page_media_1_content_hero_text: 'Pilates cvičenie',
  page_text1_hero_text: 'Recepty',
  page_text1_section_title: 'Výživa',
  page_text1_subheader_text: 'Recepty',
  page_text2_hero_text: 'Náš blog',
  page_text2_section_title: 'Blog',
  page_text2_subheader_text: 'Články a správy',
  enter_email_title: 'Ak chcete pokračovať, zadajte svoj e-mail',
  enter_email_placeholder_email: 'Email',
  enter_email_button_enter: 'Zadajte',
  components_login_success_text: 'Prihlásenie úspešné!',
  components_card_link_media_content: 'Pozerať teraz',
  components_card_link_text1_content: 'Zobraziť Recept',
  components_card_link_text2_content: 'Zobraziť článok',
  france: 'Francúzsko',
  cyprus: 'Cyprus',
};
